import { render, staticRenderFns } from "./SKUAdd.vue?vue&type=template&id=1c13ad9f&scoped=true"
import script from "./SKUAdd.vue?vue&type=script&lang=js"
export * from "./SKUAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13ad9f",
  null
  
)

export default component.exports